import { t } from "@/i18n-js/instance";
import { useFetchSpaces } from "@/react/components/SettingsApp/Workflows/hooks/useFetchSpaces";
import { FormTextSelect } from "@circle-react-uikit/Form/FormTextSelect";
import { Loader } from "@circle-react-uikit/Loader";
import { Typography } from "@circle-react-uikit/Typography";
import { useCurrentAction } from "../../../ActionRule";

const i18nRoot = "settings.workflows.form";

interface Space {
  id: number;
  name: string;
  space_group_name?: string;
}

interface SpaceOption {
  label: string;
  value: number;
}

interface SpacesData {
  count?: number;
  records: Space[];
}

export const FormSelectSpace = (): JSX.Element => {
  const { paramsPath } = useCurrentAction();

  const { data, isLoading, isError } = useFetchSpaces();
  const { records: spaces = [] } = (data as SpacesData) || {};

  const options: SpaceOption[] = spaces.map((space: Space) => ({
    value: space.id,
    label: [space.space_group_name, space.name].filter(Boolean).join(" › "),
  }));

  if (isLoading) {
    return <Loader center />;
  }

  if (isError) {
    return (
      <Typography.LabelXs>
        <span className="text-v2-danger">
          {t([i18nRoot, "spaces.fetch_failed"])}
        </span>
      </Typography.LabelXs>
    );
  }

  return (
    <FormTextSelect
      name={`${paramsPath}.space_id`}
      label={
        <Typography.LabelSm weight="semibold">
          {t([i18nRoot, "select_space"])}
        </Typography.LabelSm>
      }
      options={options}
      rules={{
        required: t([i18nRoot, "errors.required"]),
      }}
      emptyMessage={t([i18nRoot, "errors.spaces.not_found"])}
    />
  );
};
